import { Box, Card, CardBody, CardHeader, Flex } from '@chakra-ui/react';
import { SsiIndicator } from './ssi-indicator';
import { SsiDetails } from './ssi-details';
import { SsiBoxHeader } from './ssi-box-header';
import { useSession } from 'next-auth/react';
import { getToken } from '../../firebaseClient';
import { useEffect, useState } from 'react';
import { MessageBox } from 'components/message-box/message-box';
import { Session } from 'next-auth/core/types';
import PuffLoader from 'react-spinners/PuffLoader';

export async function createSsiScore(session) {
  const token = await getToken(session, 'createSsiScore');
  const user = session.user;
  const response = await fetch(
    'https://us-central1-ez4cast.cloudfunctions.net/linkedinFetcher-fetchSsiScoreByUser',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        tokenuserid: session.user.uid,
      },
      body: JSON.stringify({
        isInfluentLeader: true,
        userId: user?.uid,
      }),
    }
  );

  const json = await response.json();

  return json.success ? json.ssiScore : null;
}

export const SsiScore = () => {
  const { data: session, status } = useSession() ?? {};
  const [isBlured, setIsBlured] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [data, setData] = useState<Session['user']['data']['ssiScore'] | null>(
    null
  );

  useEffect(() => {
    const fetchSsiScore = async () => {
      setIsLoading(true);
      const ssiScore = await createSsiScore(session);
      if (ssiScore) {
        setData(ssiScore);
        setIsLoading(false);
        setIsError(false);
      } else {
        setIsError(true);
      }
    };

    if (session) {
      const ssiScore = session?.user?.data?.ssiScore;

      if (!ssiScore) {
        fetchSsiScore();
      } else {
        setIsLoading(false);
        setData(ssiScore);
      }
    }
  }, [session]);

  useEffect(() => {
    setIsBlured(isLoading || isError);
  }, [isLoading, isError]);

  return (
    <Flex
      gap={4}
      flexDirection={['column', 'column', 'column', 'row']}
      flexGrow={1}
    >
      <Card w={['100%', '100%', '100%', '336px']} flexGrow={1}>
        <Flex
          flexDirection='column'
          filter={isBlured ? 'auto' : undefined}
          blur={isBlured ? '2px' : undefined}
        >
          <CardHeader>
            <SsiBoxHeader title='Social Selling Index' />
          </CardHeader>
          <CardBody>
            <SsiIndicator
              score={data?.overall}
              isLoading={isBlured}
              updatedOn={data?.updatedOn}
            />
          </CardBody>
        </Flex>
        {isLoading && (
          <Box
            flexDirection='column'
            justifyContent='center'
            alignItems='center'
            display='flex'
            position='absolute'
            top={0}
            left={0}
            w='100%'
            h='100%'
          >
            <PuffLoader
              color={'#0A66C2'}
              loading={true}
              cssOverride={{
                display: 'block',
                margin: '0 auto',
                borderColor: 'red',
              }}
              size={50}
            />
          </Box>
        )}
        {isError && (
          <Box
            justifyContent='center'
            alignItems='center'
            display='flex'
            position='absolute'
            top={0}
            left={0}
            w='100%'
            h='100%'
          >
            <MessageBox message='Loading SSI Score failed' />
          </Box>
        )}
      </Card>
      <Card w={['100%', '100%', '100%', '336px']} flexGrow={1}>
        <Flex
          flexDirection='column'
          filter={isBlured ? 'auto' : undefined}
          blur={isBlured ? '2px' : undefined}
        >
          <CardHeader>
            <SsiBoxHeader title='SSI details' />
          </CardHeader>
          {data?.subScores && (
            <CardBody>
              <SsiDetails
                scores={data.subScores}
                delta={data.delta.subScores}
              />
            </CardBody>
          )}
        </Flex>
        {isLoading && (
          <Box
            flexDirection='column'
            justifyContent='center'
            alignItems='center'
            display='flex'
            position='absolute'
            top={0}
            left={0}
            w='100%'
            h='100%'
          >
            <PuffLoader
              color={'#0A66C2'}
              loading={true}
              cssOverride={{
                display: 'block',
                margin: '0 auto',
                borderColor: 'red',
              }}
              size={50}
            />
          </Box>
        )}
      </Card>
    </Flex>
  );
};
